<div class="wrapper-page">
  <div class="wrapper-header-page">
    <div class="overlay-illustration-header"></div>
  </div>
  <div class="wrapper-content-page">
    <div class="wrapper-header-page-content">
      <span class="header-text">Iskustva korisnika</span>
      <div class="">
        <button (click)="isCreateUserExperienceModalOpen = true" class="zc-btn zc-btn--primary"><span>Dodaj</span>
        </button>
      </div>
    </div>
    <div class="wrapper-user-experiences">
      <div class="grid">
        <div *ngFor="let userExperience of userExperiences" class="grid__s-3">
          <div class="card-user-experiences">
            <div class="edit-user-experiences">
              <i (click)="userExperienceForEdit = userExperience" class="fa-solid fa-pen-to-square"></i>
              <i (click)="userExperienceForDelete = userExperience" class="fa-solid fa-trash"></i>
            </div>

            <span class="description-card-user-experiences">{{ userExperience.description }}</span>
            <div class="wrapper-user-profile">
              <img [src]="userExperience.image.full_path" alt="">
              <span>{{ userExperience.author }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <gr-create-or-edit-user-experience-modal
    *ngIf="isCreateUserExperienceModalOpen || userExperienceForEdit !== null"
    [userExperienceForEdit]="userExperienceForEdit"
    (closeModal)="isCreateUserExperienceModalOpen = false; userExperienceForEdit = null"
    (confirmCreateExperience)="onConfirmCreateOrEditUserExperience($event)"
    (confirmEditExperience)="onConfirmCreateOrEditUserExperience($event, true)"
  ></gr-create-or-edit-user-experience-modal>

  <gr-confirm-modal
    *ngIf="userExperienceForDelete !== null"
    [modalTitle]="'Brisanje recenzije'"
    [modalDescription]="'Da li ste sigurni da zelite da obrišete recenziju?'"
    (closeModal)="userExperienceForDelete = null"
    (confirmModal)="onConfirmDeleteUserExperience()"
  ></gr-confirm-modal>
</div>
